"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// index.ts
var _polygonclipping = require('polygon-clipping'); var _polygonclipping2 = _interopRequireDefault(_polygonclipping);
var _helpers = require('@turf/helpers');
var _meta = require('@turf/meta');
function difference(features) {
  const geoms = [];
  _meta.geomEach.call(void 0, features, (geom) => {
    geoms.push(geom.coordinates);
  });
  if (geoms.length < 2) {
    throw new Error("Must have at least two features");
  }
  const properties = features.features[0].properties || {};
  const differenced = _polygonclipping2.default.difference(geoms[0], ...geoms.slice(1));
  if (differenced.length === 0)
    return null;
  if (differenced.length === 1)
    return _helpers.polygon.call(void 0, differenced[0], properties);
  return _helpers.multiPolygon.call(void 0, differenced, properties);
}
var turf_difference_default = difference;



exports.default = turf_difference_default; exports.difference = difference;
//# sourceMappingURL=index.cjs.map